import React from 'react'

function TermsCondition() {
  return (
    <div>TermsCondition Coming Soon</div>
  )
}

export default TermsCondition